
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';

const PageTitle = () => {
  const { t } = useLanguage();
  const location = useLocation();
  
  // Function to get current page title based on route
  const getCurrentPageTitle = () => {
    const path = location.pathname;
    
    if (path === '/') return '';
    if (path === '/tours') return '';
    if (path.startsWith('/tours/')) return '';
    if (path === '/exhibit-access') return '';
    if (path.startsWith('/exhibit/')) return '';
    if (path === '/favorites') return t('favorites');
    if (path === '/visitor-info') return '';
    
    return '';
  };

  return (
    <h1 className="text-lg font-medium text-museum">
      {getCurrentPageTitle()}
    </h1>
  );
};

export default PageTitle;
